import { render, staticRenderFns } from "./InsuranceAdmin.vue?vue&type=template&id=ffe516d6"
import script from "./InsuranceAdmin.vue?vue&type=script&lang=js"
export * from "./InsuranceAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports